// sweetalert-theme.js
// Centraliza los estilos para SweetAlert2 en la app ETH-PPL

export const SWEETALERT_THEME = {
  background: "#f8fafc", // slate-50
  color: "#1e293b", // slate-800
  customClass: {
    container: "!z-[20001]",
    popup: "rounded-2xl border border-white/60 shadow-xl backdrop-blur-md font-montserrat !z-[20001]",
    title: "font-bold text-[#1E5B4F] text-xl md:text-2xl",
    confirmButton: "!bg-[#C49A1F] !text-white !rounded-lg !px-6 !py-2 !font-semibold !shadow-md hover:!bg-[#A9821A]",
    cancelButton: "!bg-red-500 !text-white !rounded-lg !px-6 !py-2 !font-semibold !border !border-red-700 hover:!bg-red-600",
    denyButton: "!bg-[#1E5B4F]/90 !text-white !rounded-lg !px-6 !py-2 !font-semibold !border !border-slate-300 hover:!bg-[#1E5B4F]/100",
    actions: "gap-3 flex-row-reverse justify-center",
    icon: "!mt-2",
    htmlContainer: "text-base text-slate-700",
  },
  buttonsStyling: false,
};
